(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tallow-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tu-reveal')) {
    // Fades children up once when scrolled into view, like the live site's framer-motion whileInView
    customElements.define(
      'tu-reveal',
      class extends HTMLElement {
        connectedCallback() {
          const motionOff = getComputedStyle(document.documentElement).getPropertyValue('--tu-motion').trim() === 'off';
          if (window.Shopify?.designMode || motionOff || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          this.classList.add('is-armed');
          this.observer = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.observer.disconnect();
            this.classList.add('is-visible');
            // Hand transitions back to the children (e.g. button hover) once the last one lands
            this.addEventListener('transitionend', (event) => {
              if (event.target !== this.lastElementChild || event.propertyName !== 'transform') return;
              this.classList.remove('is-armed', 'is-visible');
            });
          });
          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tallow-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tu-gallery')) {
    class TallowGallery extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-tu-slide]')];
        this.index = 0;
        this.querySelector('[data-tu-prev]')?.addEventListener('click', () => this.go(this.index - 1, -1));
        this.querySelector('[data-tu-next]')?.addEventListener('click', () => this.go(this.index + 1, 1));
        this.querySelectorAll('[data-tu-goto]').forEach((button) => {
          button.addEventListener('click', () => {
            const i = Number(button.dataset.tuGoto);
            this.go(i, i > this.index ? 1 : -1);
          });
        });
        this.addEventListener('shopify:block:select', (event) => {
          const i = this.slides.indexOf(event.target);
          if (i < 0) return;
          this.stop();
          this.go(i, i > this.index ? 1 : -1);
        });
        // Like the live site: advance every few seconds (section setting), and manual navigation doesn't reset the timer
        const seconds = Number(this.dataset.interval);
        if (this.slides.length > 1 && seconds > 0 && !window.Shopify?.designMode) {
          this.timer = setInterval(() => this.go(this.index + 1, 1), seconds * 1000);
        }
      }

      disconnectedCallback() {
        this.stop();
      }

      stop() {
        clearInterval(this.timer);
      }

      go(i, direction) {
        const count = this.slides.length;
        const next = (i + count) % count;
        if (next === this.index) return;

        const incoming = this.slides[next];
        const outgoing = this.slides[this.index];
        const offset = direction > 0 ? 100 : -100;

        // Start the incoming slide off to one side without animating, then slide it in
        incoming.style.transition = 'none';
        incoming.style.transform = `translateX(${offset}%)`;
        incoming.offsetWidth;
        incoming.style.transition = '';
        incoming.style.transform = '';
        outgoing.style.transform = `translateX(${-offset}%)`;

        this.index = next;
        this.slides.forEach((slide, n) => {
          const active = n === this.index;
          slide.classList.toggle('is-active', active);
          slide.toggleAttribute('aria-hidden', !active);
        });
        this.querySelectorAll('.tu-gallery__dot').forEach((dot, n) => {
          dot.classList.toggle('is-active', n === this.index);
          dot.toggleAttribute('aria-current', n === this.index);
        });
        this.querySelectorAll('.tu-gallery__thumb').forEach((thumb, n) => {
          thumb.classList.toggle('is-active', n === this.index);
        });
      }
    }

    customElements.define('tu-gallery', TallowGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tallow-product-buy"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tu-buy-box')) {
    class TallowBuyBox extends HTMLElement {
      connectedCallback() {
        this.qty = this.querySelector('[data-tu-qty]');
        this.minus = this.querySelector('[data-tu-step="-1"]');
        this.select = this.querySelector('[data-tu-variant-select]');
        this.submit = this.querySelector('[data-tu-submit]');
        this.submitLabel = this.querySelector('[data-tu-submit-label]');
        this.prices = this.querySelectorAll('[data-tu-price]');

        try {
          this.variants = JSON.parse(this.querySelector('[data-tu-variants]').textContent);
        } catch (error) {
          this.variants = [];
        }

        this.querySelectorAll('[data-tu-step]').forEach((button) => {
          button.addEventListener('click', () => this.step(Number(button.dataset.tuStep)));
        });
        this.qty?.addEventListener('change', () => this.step(0));
        this.qty?.addEventListener('input', () => this.updateTotal());
        this.select?.addEventListener('change', () => this.updateVariant());

        // The button shows quantity × unit price. Wholesale buyers also get the price tier for that quantity.
        this.variantId = this.select?.value ?? this.querySelector('input[name="id"]')?.value;
        this.updateTotal();
      }

      step(delta) {
        if (!this.qty) return;
        const next = Math.max(1, (parseInt(this.qty.value, 10) || 1) + delta);
        this.qty.value = next;
        if (this.minus) this.minus.disabled = next <= 1;
        this.updateTotal();
      }

      updateTotal() {
        const variant = this.variants.find((v) => String(v.id) === String(this.variantId));
        if (!variant?.available || !this.submitLabel) return;

        const quantity = Math.max(1, parseInt(this.qty?.value, 10) || 1);
        const tier = (variant.breaks || [])
          .filter((b) => quantity >= b.min)
          .reduce((best, b) => (!best || b.min > best.min ? b : best), null);
        const cents = (tier ? tier.cents : variant.cents) * quantity;

        let total;
        try {
          total = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency }).format(
            cents / 100
          );
        } catch (error) {
          total = (cents / 100).toFixed(2);
        }
        this.submitLabel.textContent = `${this.dataset.buyLabel} — ${total}`;
      }

      updateVariant() {
        const variant = this.variants.find((v) => String(v.id) === this.select.value);
        if (!variant) return;

        this.prices.forEach((el) => (el.textContent = variant.price));
        this.querySelectorAll('[data-tu-tiers]').forEach((tiers) => {
          tiers.hidden = tiers.dataset.tuTiers !== String(variant.id);
        });
        if (this.submit) this.submit.disabled = !variant.available;
        if (this.submitLabel) {
          this.submitLabel.textContent = variant.available
            ? `${this.dataset.buyLabel} — ${variant.price}`
            : this.dataset.soldOutLabel;
        }

        this.variantId = variant.id;
        this.updateTotal();
      }
    }

    customElements.define('tu-buy-box', TallowBuyBox);
  }

  if (!customElements.get('tu-buy-slider')) {
    class TallowBuySlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-tu-track]');
        this.count = this.track.children.length;
        this.dots = [...this.querySelectorAll('[data-tu-dot]')];
        this.index = 0;

        this.querySelector('[data-tu-prev]').addEventListener('click', () => this.go(this.index - 1));
        this.querySelector('[data-tu-next]').addEventListener('click', () => this.go(this.index + 1));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));
        this.track.addEventListener('scroll', () => this.sync(), { passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.go(this.index - 1);
          if (event.key === 'ArrowRight') this.go(this.index + 1);
        });

        const start = Number(this.dataset.start) || 0;
        if (start) requestAnimationFrame(() => this.go(start, 'instant'));
      }

      go(i, behavior) {
        const reduce =
          window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
          getComputedStyle(document.documentElement).getPropertyValue('--tu-motion').trim() === 'off';
        this.index = (i + this.count) % this.count;
        this.track.scrollTo({
          left: this.index * this.track.clientWidth,
          behavior: behavior || (reduce ? 'instant' : 'smooth'),
        });
        this.updateDots();
      }

      sync() {
        const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
        if (index === this.index) return;
        this.index = index;
        this.updateDots();
      }

      updateDots() {
        this.dots.forEach((dot, i) => {
          if (i === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    }

    customElements.define('tu-buy-slider', TallowBuySlider);
  }

  } catch(e) { console.error(e); }
})();
})();
